<template>
  <div class="file-thumbnail" :style="style">
    <img :src="dataUrl" />
  </div>
</template>

<script>
import { store } from "../store";

export default {
  name: "FileThumbnail",
  props: {
    fileId: {
      type: String
    },
    width: {
      type: String,
      default: "80"
    }
  },
  computed: {
    style() {
      return {
        width: this.width + "px",
        height: this.width + "px"
      };
    },
    dataUrl() {
      return URL.createObjectURL(store.state.files[this.fileId]);
    }
  }
};
</script>

<style lang="scss">
.file-thumbnail {
  border: 1px solid rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.2);
  border-radius: 5px;
  background: white;
  position: relative;
  overflow: hidden;
  img {
    object-fit: cover;
    height: 100%;
    width: 100%;
  }
}
</style>
